import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, ListMethodArg, ListMethodResponse, GetMethodResponse, ModelClass, References } from '/imports/types';

export interface PriceSource extends Doc {
  _id: string;
  type: string;
  url: string;
}

type Model = PriceSource;
type Refs = References<Model>;

export const PriceSources = new Mongo.Collection<PriceSource>('priceSources');

export const listPriceSources = DeclareMethod<ListMethodArg<PriceSource>, ListMethodResponse<PriceSource, Refs>>('listPriceSources');
export const getPriceSource = DeclareMethod<string, GetMethodResponse<PriceSource, Refs>>('getPriceSource');
export const createPriceSource = DeclareMethod<Partial<PriceSource>, string>('createPriceSource');
export const updatePriceSource = DeclareMethod<Partial<PriceSource>, string>('updatePriceSource');
export const deletePriceSource = DeclareMethod<string, undefined>('deletePriceSource');

export const modelClass: ModelClass<Model, Refs> = {
  collection: PriceSources,
  editableFields: ['type', 'url'],
  listMethod: listPriceSources,
  getMethod: getPriceSource,
  createMethod: createPriceSource,
  updateMethod: updatePriceSource,
  deleteMethod: deletePriceSource,
  pathPrefix: '/price-sources',
  modelName: 'Price Source',
  pluralName: 'Price Sources',
};
